export const GET_CREDIT_USER = 'GET_CREDIT_USER'
export const UPDATE_CREDIT_USER = 'UPDATE_CREDIT_USER'
export const DELETE_CREDIT_USER = 'DELETE_CREDIT_USER'
export const UPDATE_DATOS_VARIOS = 'UPDATE_DATOS_VARIOS'
export const UPDATE_DEUDA_HOY_BACKEND = 'UPDATE_DEUDA_HOY_BACKEND'
